import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function StudentCouncil() { 
  useEffect(() => {
    document.title = 'Student Council -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> Academics</li>
                <li>Student Council</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Student Council</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                    
               <p>The Students' Council comprises of The President, Vice President, Speaker and a democratically elected body of student representatives. Two members, a boy and a girl, are elected from each section of each class from VII to XII. Three members of the faculty are appointed as advisors to the Students' Council. The members of the Prefects' Council work together as a team to uphold the rules and regulations of the school and help to maintain discipline. Through their work as prefects they learn the valuable lesson that with authority comes responsibilities and its associated challenges. The Prefects' Council is the first step towards our goal of creating conscientious and responsible global citizens.</p>
               <h3 className="smallheading">The House System</h3>
               <p>All the students are divided into four house viz.</p>
               <div className="table-responsive">
                    <table className="table maintable">
                        <tbody>
                           <tr>
                           <td>ASTHA  MISHRA</td>
                           <td>XII - A</td>
                           <td>Head Girl</td>
                           </tr>
                           <tr>
                           <td>SURYANSH SINGH</td>
                           <td>XII - A</td>
                           <th>Head Boy</th>
                           </tr>
                           <tr>
                           <td>ARYAN SACHAN</td>
                           <td>XII - A</td>
                           <th>Sports In-charge</th>
                           </tr>
                           <tr>
                           <td>SHEREEN FATIMA</td>
                           <td>XII - A</td>
                           <th>Sports In-charge</th>
                           </tr>
                           <tr>
                           <td>SHWETA AWASTHI</td>
                           <td>XII - A</td>
                           <th>Discipline Incharge</th>
                           </tr>
                           <tr>
                           <td>ARJUN PANDEY</td>
                           <td>XI - A</td>
                           <th>Discipline Incharge</th>
                           </tr>
                           <tr>
                           <td>SHOBHIT DWIVEDI</td>
                           <td>XI- B</td>
                           <th>Discipline Incharge</th>
                           </tr>
                           <tr>
                           <td>MANI SHUKLA</td>
                           <td>XI - C</td>
                           <th>Discipline Incharge</th>
                           </tr>
                           </tbody>
                   </table>
               </div>
               <div className="housebox">
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item">
                                   <h2 className="accordion-header" id="headingOne">
                                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                        RED House – Warriors
                                     </button>
                                   </h2>
                                   <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                     <div className="accordion-body">
                                            <div className="table-responsive">
                                                  <table className="table maintable">
                                                        <tbody>
                                                             <tr>
                                                           <td>ARYAN VERMA</td>
                                                           <td>XII - B</td>
                                                           <td>House Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>YASHI  TIWARI</td>
                                                           <td>XII - C</td>
                                                           <td>House Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>SAMEER SAXENA</td>
                                                           <td>X - B</td>
                                                           <td>House Vice-Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ACHINT KAUR</td>
                                                           <td>XI - C</td>
                                                           <td>House Vice-Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>AVIRAL BAJPAI</td>
                                                           <td>X - B</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>SHYAM PANGORIA</td>
                                                           <td>X - A</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ANUSHKA BAJPAI</td>
                                                           <td>X - B</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>SHANTANU TRIVEDI</td>
                                                           <td>IX - A</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>AARADHYA SRIVASTAVA</td>
                                                           <td>IX - B</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>VEDANSHI SHUKLA</td>
                                                           <td>IX - D</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>RISHIT MEHROTRA</td>
                                                           <td>IX - E</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           </tbody>
                                                  </table>
                                           </div>
                                     </div>
                                   </div>
                                 </div>
                               <div className="accordion-item">
                                   <h2 className="accordion-header" id="headingTwo">
                                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                         BLUE House – Troopers
                                     </button>
                                   </h2>
                                   <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                     <div className="accordion-body">
                                            <div className="table-responsive">
                                                  <table className="table maintable">
                                                         <tbody>
                                                             <tr>
                                                           <td>ANSH GUPTA</td>
                                                           <td>XII - A</td>
                                                           <td>House Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ISHA BHATIA</td>
                                                           <td>XII - A</td>
                                                           <td>House Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>NEIL HENRY PAUL</td>
                                                           <td>XI - A</td>
                                                           <td>House Vice-Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>MAHEK DWIVEDI</td>
                                                           <td>XI - B</td>
                                                           <td>House Vice-Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>AARYA DUBEY</td>
                                                           <td>X - A</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>EKANSH BAJPAI</td>
                                                           <td>IX - B</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ALBIN TOM</td>
                                                           <td>IX - C</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>SUHANI DUA</td>
                                                           <td>IX - E</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ARYAN MISHRA</td>
                                                           <td>IX - B</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           </tbody>
                                                  </table>
                                           </div>
                                     </div>
                                   </div>
                                 </div>
                               <div className="accordion-item">
                                       <h2 className="accordion-header" id="headingThree">
                                         <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                           GREEN House – Commanders
                                         </button>
                                       </h2>
                                       <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                         <div className="accordion-body">
                                                <div className="table-responsive">
                                                      <table className="table maintable">
                                                           <tbody>
                                                             <tr>
                                                           <td>HARSH AGARWAL</td>
                                                           <td>XII - C</td>
                                                           <td>House Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ANUSHKA SRIVASTAVA</td>
                                                           <td>XII - D</td>
                                                           <td>House Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>TARUN TIWARI</td>
                                                           <td>XI - A</td>
                                                           <td>House Vice-Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>DISHA SINGH</td>
                                                           <td>XI - A</td>
                                                           <td>House Vice-Captain</td>
                                                           </tr>
                                                           <tr>
                                                           <td>MEHER  VANSHIKA NIGAM</td>
                                                           <td>X - D</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>SATYAM TRIVEDI</td>
                                                           <td>X - A</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ARINIMA GUPTA</td>
                                                           <td>X - B</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>TANMAY SHUKLA</td>
                                                           <td>IX - A</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>ADITI ARYA</td>
                                                           <td>IX - B</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           <tr>
                                                           <td>SHOEBA KHAN</td>
                                                           <td>IX - C</td>
                                                           <td>Prefect</td>
                                                           </tr>
                                                           </tbody>
                                                      </table>
                                               </div>
                                         </div>
                                       </div>
                                     </div>
                               <div className="accordion-item">
                   <h2 className="accordion-header" id="headingFour">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                       YELLOW House - Gladiators
                     </button>
                   </h2>
                   <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                     <div className="accordion-body">
                            <div className="table-responsive">
                                  <table className="table maintable">
                                              <tbody>
                                                 <tr>
                                               <td>TANMAY MISHRA</td>
                                               <td>XII - A</td>
                                               <td>House Captain</td>
                                               </tr>
                                               <tr>
                                               <td>ISHIKA MALHOTRA</td>
                                               <td>XII - C</td>
                                               <td>House Captain</td>
                                               </tr>
                                               <tr>
                                               <td>SUYASH SHARMA</td>
                                               <td>XII - B</td>
                                               <td>House Vice-Captain</td>
                                               </tr>
                                               <tr>
                                               <td>MEGHNA SHARMA</td>
                                               <td>XI - B</td>
                                               <td>House Vice-Captain</td>
                                               </tr>
                                               <tr>
                                               <td>PRAGUN  DWIVEDI</td>
                                               <td>X - D</td>
                                               <td>Prefect</td>
                                               </tr>
                                               <tr>
                                               <td>NANCY SRIVASTAVA</td>
                                               <td>X - B</td>
                                               <td>Prefect</td>
                                               </tr>
                                               <tr>
                                               <td>SHANICA  PANDEY</td>
                                               <td>IX - E</td>
                                               <td>Prefect</td>
                                               </tr>
                                               <tr>
                                               <td>SANCHALI MISHRA</td>
                                               <td>IX - A</td>
                                               <td>Prefect</td>
                                               </tr>
                                               <tr>
                                               <td>RIYA PAL</td>
                                               <td>IX - D</td>
                                               <td>Prefect</td>
                                               </tr>
                                               <tr>
                                               <td>PRATHMESH DUBEY</td>
                                               <td>IX - E</td>
                                               <td>Prefect</td>
                                               </tr>
                                               </tbody>
                                                    </table>
                                             </div>
                                       </div>
                                     </div>
                                   </div>
                                              </div>
                                       </div>
                                       <p>Every house is governed by a Captain, Vice Captain and Perfects. Perfects helps the Captain and Vice Captain to carry on the responsibilities/duties bestowed upon them.</p>
                             
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default StudentCouncil;
